import { css } from "../../css/util.compose-css";

export const figure = css`
  margin: 0;
`;
